import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { LoadPanel } from 'devextreme-react/load-panel';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import moment from 'moment-timezone';
import { RuleChangeDataType } from '../common/RuleConstants';

export const RuleChangesHistoryModal = ({ isOpen = false, changeId, onClose }) => {
    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        form: { paddingLeft: '5px', paddingTop: '10px' },
        formRow: { marginBottom: '0' },
    };

    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage] = useState('Loading...');
    const [change, set_change] = useState(null);
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);

    const _onClose = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose && onClose();
    };

    const loadDetails = async (id) => {
        set_loadingOpen(true);
        const response = await experienceApi.getRuleChangeHistoryDetail(id);
        if (!response || response.statusCode !== 200) {
            return;
        }
        set_change(response.result);
    };

    useEffect(() => {
        async function changeIdChanged() {
            if (!changeId || changeId <= 0) {
                return;
            }

            await loadDetails(changeId);
            set_loadingOpen(false);
        }

        changeIdChanged();
    }, [isOpen, changeId]);

    const formatDateTime = (date) => {
        const centralTime = moment.utc(date).tz('America/Chicago');
        return `${centralTime.format('MM/DD/YYYY')} ${centralTime.format('HH:mm:ss')} CT `;
    };

    const onCellRender = (e) => {
        switch (e.data.dataTypeId) {
            case RuleChangeDataType.Double:
                if (e.value) {
                    const val = parseFloat(e.value);
                    return val;
                }
                return e.value;
            default:
                return e.value;
        }
    };

    if (!isOpen || !change) {
        return null;
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_onClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex={-1}
                            role='dialog'
                            style={{ width: '800px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1 style={{ whiteSpace: 'nowrap' }}>Audit History Details</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={_onClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div
                                className='main-content no-search'
                                style={{ padding: '10px' }}
                            >
                                <div
                                    style={styles.form}
                                    className={'standard-form'}
                                >
                                    <div
                                        className='row'
                                        style={styles.formRow}
                                    >
                                        <div className='columns small-12 large-12'>
                                            <table>
                                                <tr>
                                                    <td
                                                        style={{
                                                            width: '140px',
                                                        }}
                                                    >
                                                        Timestamp:
                                                    </td>
                                                    <td>{formatDateTime(change.dateAndTime)}</td>
                                                </tr>
                                                <tr>
                                                    <td>User:</td>
                                                    <td>{change.userName}</td>
                                                </tr>
                                                <tr>
                                                    <td>Reason:</td>
                                                    <td>{change.reason}</td>
                                                </tr>
                                                <tr>
                                                    <td>Notes:</td>
                                                    <td>{change.notes}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div>
                                        <DataGrid
                                            dataSource={change.entries}
                                            showBorders={true}
                                            showRowLines={false}
                                            showColumnHeaders={true}
                                            rowAlternationEnabled={true}
                                            columnMinWidth={50}
                                            columnAutoWidth={false}
                                            allowSorting={true}
                                            allowColumnResizing={true}
                                            height={350}
                                        >
                                            <Scrolling mode='virtual' />
                                            <Column
                                                dataField='sectionName'
                                                caption='Section'
                                                width={140}
                                            />
                                            <Column
                                                dataField='fieldName'
                                                caption='Field'
                                                width={160}
                                            />
                                            <Column
                                                dataField='changeType'
                                                caption='Type'
                                                width={80}
                                            />
                                            <Column
                                                dataField='fromValue'
                                                caption='Old Value'
                                                width={180}
                                                cellRender={onCellRender}
                                            />
                                            <Column
                                                dataField='toValue'
                                                caption='New Value'
                                                width={180}
                                                cellRender={onCellRender}
                                            />
                                        </DataGrid>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='button-footer'
                                style={styles.buttonContainer}
                            >
                                <button
                                    style={styles.buttonMarginRight}
                                    type='button'
                                    className='button primary'
                                    onClick={_onClose}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </>
    );
};
